
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCommandShared as ObiCommandSharedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-command-shared.js';
 
 
 

 
 export const ObiCommandShared = createComponent({
   react: React,
   tagName: 'obi-command-shared',
   elementClass: ObiCommandSharedElement,
   events: {
     
   }
  });
 
 